import axiosInstance from '../utils/axiosInstance';

const api = axiosInstance;

export async function getAllPaymentMethodCategories() {
  const { data: categories } = await api.get(
    '/mkService/payment-config/v1/payment-method-categories'
  );
  return categories;
}

export async function getAllConfigurablePaymentMethods() {
  const { data: paymentMethods } = await api.get(
    '/mkService/payment-config/v1/payment-methods',
    {
      params: {
        configurable: true,
      },
    }
  );
  return paymentMethods;
}

export async function getAllPaymentMethods() {
  const { data: paymentMethods } = await api.get(
    '/mkService/payment-config/v1/payment-methods'
  );

  return paymentMethods;
}

export async function getConfigurationList() {
  const { data: configurations } = await api.get(
    '/mkService/payment-config/v1/configurations'
  );
  return configurations;
}

export async function getConfigurationDetail(configurationId) {
  const { data: configuration } = await api.get(
    `/mkService/payment-config/v1/configurations/${configurationId}`
  );
  return configuration;
}

export async function postNewConfiguration(newConfiguration) {
  const { data: configuration } = await api.post(
    '/mkService/payment-config/v1/configurations',
    newConfiguration
  );
  return configuration;
}

export async function deleteConfiguration(configurationId) {
  const { data: configuration } = await api.delete(
    `/mkService/payment-config/v1/configurations/${configurationId}`
  );
  return configuration;
}

export async function updateConfiguration(configurationId, patchBody) {
  const { data: configuration } = await api.put(
    `/mkService/payment-config/v1/configurations/${configurationId}`,
    patchBody
  );
  return configuration;
}

export async function getOutletConfigurationLinks() {
  const { data: links } = await api.get(
    '/mkService/payment-config/v1/configurations/outlets'
  );
  return links;
}
